export default "__VITE_ASSET__C45s5pl___"